import React from 'react';
import Icon from '../../../components/AppIcon';

const AuthTabs = ({ activeTab, onTabChange, isLoading }) => {
  const tabs = [
    {
      id: 'password',
      label: 'Password',
      icon: 'Lock',
      description: 'Sign in with email and password'
    },
    {
      id: 'magic-link',
      label: 'Magic Link',
      icon: 'Mail',
      description: 'Sign in with email link'
    }
  ];

  return (
    <div className="mb-8">
      <div className="flex bg-muted rounded-lg p-1">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            disabled={isLoading}
            className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-md text-sm font-medium transition-smooth ${
              activeTab === tab?.id
                ? 'bg-surface text-primary shadow-sm'
                : 'text-text-secondary hover:text-primary'
            } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <Icon name={tab?.icon} size={16} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>
      <div className="mt-3 text-center">
        <p className="text-xs text-text-secondary">
          {tabs?.find(tab => tab?.id === activeTab)?.description}
        </p>
      </div>
    </div>
  );
};

export default AuthTabs;